var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonlightText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2655",
    "data-name": "Group 2655",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1823.624,
    height: 214.743,
    viewBox: "0 0 1823.624 214.743",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M450.286,288.162h2.479V494.911h-20.83q-18.616,0-18.756-18.621V390.37l-64.542,77.647L284.222,390.37v85.92q0,18.616-18.756,18.621H244.637V288.162h2.478l101.524,119.45Z",
    transform: "translate(-244.637 -284.16)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M375.119,502.518q-47.449,0-77.242-30.958T268.09,395.085q0-45.241,29.787-76.268,29.8-31.042,77.242-31.041,47.713,0,77.512,30.968t29.8,76.413q0,45.442-29.8,76.4T375.119,502.518Zm48.066-157.573q-19.8-20.2-48.066-20.2t-47.994,20.2q-19.735,20.218-19.73,50.213t19.73,50.264q19.72,20.279,47.994,20.279t48.066-20.279q19.782-20.264,19.792-50.264Q442.978,365.141,423.186,344.944Z",
    transform: "translate(-24.928 -287.776)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M398.159,502.518q-47.449,0-77.242-30.958T291.13,395.085q0-45.241,29.787-76.268,29.8-31.042,77.242-31.041,47.729,0,77.511,30.968,29.8,30.965,29.8,76.413t-29.8,76.4Q445.888,502.523,398.159,502.518Zm48.066-157.573q-19.8-20.2-48.066-20.2t-47.994,20.2q-19.736,20.218-19.73,50.213t19.73,50.264q19.72,20.279,47.994,20.279t48.066-20.279q19.782-20.264,19.792-50.264Q466.017,365.141,446.225,344.944Z",
    transform: "translate(190.911 -287.776)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M494.756,494.911h-4.137L354.487,372.019V476.29q0,18.616-18.757,18.621H315.182V288.162h4.271l135.853,125.1V306.783q0-18.616,18.62-18.621h20.829Z",
    transform: "translate(416.231 -284.16)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M376.45,459.878h90.606q18.632,0,18.62,18.621v16.413H336.865V288.162h20.829q18.616,0,18.756,18.621Z",
    transform: "translate(619.359 -284.16)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M374.843,288.162q18.616,0,18.62,18.621V494.911H372.5q-18.616,0-18.62-18.621V288.162Z",
    transform: "translate(778.746 -284.16)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M572.256,385.314a209.849,209.849,0,0,1,0,26.48q-3.437,40.139-31.1,65.308-27.651,25.179-70.264,25.164-46.08,0-77.865-31.374t-31.788-75.718q0-44.339,31.374-75.853T468.264,287.8a103.876,103.876,0,0,1,50.886,12.9,106.954,106.954,0,0,1,38.072,34.816L538.6,347.108q-12.969,8.133-25.929-3.867Q492.407,324.9,468.264,324.9q-28.274,0-48,20.135-19.7,20.14-19.71,50.067,0,30.218,20.343,50.275,20.326,20.078,51.1,20.073,23.422,0,39.5-12.691T530.193,420.9H472.536q-18.616,0-18.621-18.622V385.314Z",
    transform: "translate(847.657 -287.523)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M526.377,288.162h20.55q18.631,0,18.756,18.621V494.911H545q-18.616,0-18.622-18.621V412.423H424.18v82.488H403.485q-18.616,0-18.61-18.621V288.162h20.538q18.617,0,18.767,18.621V377.4h102.2Z",
    transform: "translate(1069.118 -284.16)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M563.22,288.162v16.413q0,18.615-18.621,18.621H504.2V476.29q0,18.616-18.622,18.621H464.745V323.2H405.294V306.783q0-18.616,18.755-18.621Z",
    transform: "translate(1260.404 -284.16)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonlightText);
export default __webpack_public_path__ + "static/media/moonlight-text.4b41a2a0b2db4e3b3b16ed6525a6d52b.svg";
export { ForwardRef as ReactComponent };